export const CheckMsg = {
  CHK_ISNUM: "半角数値を入力してください。",

  CHK_MAIL: "「メールアドレス」が入力されていません。",
  CHK_MAIL2: "「メールアドレス」が正しく入力されていません。",
  CHK_PWD: "「パスワード」が入力されていません。",

  CHK_TANTO_CD: "「担当者コード」が入力されていません。",
  CHK_TANTO_NM: "「担当者名」が入力されていません。",
  CHK_KENGEN: "「権限」が選択されていません。",

  CHK_KAISHA_GROUP_NM: "「会社グループ」が選択されていません。",
  CHK_KAISHA_GROUP_NM2: "「会社グループ」が入力されていません。",
  CHK_KAISHA_UNYO: "「集中型」では、複数グループは登録できません。",

  CHK_KAISHA_CD: "「会社コード」が選択されていません。",
  CHK_KAISHA_CD2: "「会社コード」が入力されていません。",
  CHK_KAISHA_CD_LENGTH: "「会社コード」は6文字以上で入力してください。",
  CHK_KAISHA_NM: "「会社名」が入力されていません。",
  CHK_KJN_NM: "「個人名」が入力されていません。",
  CHK_KJN_NM2: "「氏名」が入力されていません。",
  CHK_BUSHO_NM: "「部署名」が入力されていません。",
  CHK_UNYO: "「運用区分」が選択されていません。",

  CHK_GYOUSHU: "「業種分類名」が選択されていません。",
  CHK_GYOUSHU2: "「業種分類名」が入力されていません。",
  CHK_GYOUSHU_CD: "「業種分類コード」が入力されていません。",
  CHK_GYOUSHU_CD_LEN: "「業種分類コード」は３文字で入力してください。",

  CHK_SHINSEI_BUNRUI_NM: "「申請分類名」が選択されていません。",
  CHK_SHINSEI_BUNRUI_NM2: "「申請分類名」が入力されていません。",
  CHK_SHINSEI_BUNRUI_CD: "「申請分類コード」が入力されていません。",
  CHK_SHINSEI_BUNRUI_CD_LEN: "「申請分類コード」は２文字で入力してください。",

  CHK_SHONIN_COMMENT_SEQ: "「SEQ」が入力されていません。",
  CHK_SHONIN_COMMENT_BUNRUI: "「分類」が選択されていません。",
  CHK_SHONIN_COMMENT: "「承認コメント」が入力されていません。",

  CHK_SHINSEI_ITAKUSAKI_KAISHA_NM: "「委託先会社名」が入力されていません。",
  CHK_SHINSEI_ITAKUSAKI_JUSHO: "「委託先住所」が入力されていません。",
  CHK_SHINSEI_KAISHIBI: "「開始日」が入力されていません。",
  CHK_SHINSEI_SHURYOBI: "「終了日」が入力されていません。",
  CHK_SHINSEI_RIYO_BASHO: "「利用場所」が入力されていません。",
  CHK_SHINSEI_RIYO_MOKUTEKI: "「利用目的」が入力されていません。",
  CHK_SHINSEI_RIYO_HOHO: "「利用方法」が入力されていません。",
  CHK_SHINSEI_RIYO_HANI: "「MDBファイル」が選択されていません。",
  CHK_SHINSEI_RIYO_KOMOKU: "「利用項目」が選択されていません。",
  CHK_SHINSEI_DOI: "申請には、「同意事項」への同意が必要です。",
  CHK_SHINSEI_VALID_DATE:
    "「終了日」は「開始日」以降の日付を入力してください。",
  CHK_SHINSEI_ONE_YEAR_DATE:
    "「終了日」は「開始日」から1年以内の日付を入力してください。",
  CHK_ULT_COMMENT: "「ULTコメント」が入力されていません。",
  CHK_SHINSEI_RIYO_SONOHOKA_TEXT: "「その他」が入力されていません。",

  CHK_TOIAWASE_KENMEI: "「お問い合わせ件名」が入力されていません。",
  CHK_TOIAWASE_NAIYO: "「お問い合わせ内容」が入力されていません。",

  CHK_CORRECT_PWD: "「パスワード」が正しく入力されていません。",
  CHK_COMFIRM_PWD: "「パスワード（確認用）」が入力されていません。",
  CHK_SAME_PWD: "「パスワード」と「パスワード（確認用）」が一致しません。",
};

export const InfoMsg = {
  INFO_SYONINSHA_DELETED: "承認者が削除されました。",
  INFO_SYONINSHA_ADDED: "承認者が登録されました。",
  INFO_SYONINSHA_UPDATED: "承認者が更新されました。",

  INFO_SHINSEISHA_DELETED: "申請者が削除されました。",
  INFO_SHINSEISHA_ADDED: "申請者が登録されました。",
  INFO_SHINSEISHA_UPDATED: "申請者が更新されました。",

  INFO_KAISHA_ADDED: "会社が登録されました。",
  INFO_KAISHA_UPDATED: "会社が更新されました。",

  INFO_GROUP_ADDED: "会社グループが登録されました。",
  INFO_GROUP_UPDATED: "会社グループが更新されました。",

  INFO_GYOUSHU_ADDED: "業種分類が登録されました。",
  INFO_GYOUSHU_UPDATED: "業種分類が更新されました。",

  INFO_SHONIN_COMMENT_ADDED: "承認コメントが登録されました。",
  INFO_SHONIN_COMMENT_UPDATED: "承認コメントが更新されました。",
  INFO_SHONIN_COMMENT_DELETED: "承認コメントが削除されました。",

  INFO_SHINSEI_COMPLETED: "申請しました。",
  INFO_KARI_SHINSEI_COMPLETED: "仮申請しました。",
  INFO_SAVE_COMPLETED: "一時保存しました。",
  INFO_COPY_COMPLETED: "複写しました。",
  INFO_DELETE_COMPLETED: "削除しました。",

  INFO_SHONIN_COMPLETED: "承認しました。",
  INFO_KARI_SHONIN_COMPLETED: "仮承認しました。",
  INFO_HORYU_COMPLETED: "保留しました。",
  INFO_KARI_HORYU_COMPLETED: "仮保留しました。",
  INFO_TORIKESI_COMPLETED: "取消しました。",

  INFO_TOIAWASE_COMPLETED_PART1: "お問い合わせ内容が送信されました。",
  INFO_TOIAWASE_COMPLETED_PART2:
    "ご登録頂いたメールアドレス宛に弊社担当者よりご連絡があるまで、今しばらくおまちください。",

  INFO_TOIAWASE_UPDATED: "お問い合わせが更新されました。",
  INFO_TOIAWASE_KAITO_SENT: "回答内容が送信されました。",

  INFO_MENTE_COMMENT_UPDATED: "メンテ通知が更新されました。",

  INFO_USER_PROFILE_UPDATED: "個人情報が更新されました。",
  SET_PASSWORD_COMPLETED: "パスワード設定が完了しました",
  INfO_REPEATED_SEQ: "上記SEQが重複しています。",
};

export const ComfirmMsg = {
  CFM_KARI_SHINSEI: "仮申請しますが、よろしいでしょうか？",
  CFM_SHINSEI: "申請しますが、よろしいでしょうか？",
  CFM_COPY: "複写しますが、よろしいでしょうか？",
  CFM_SAVE: "一時保存しますが、よろしいでしょうか？",

  CFM_KARI_SHONIN: "仮承認しますが、よろしいでしょうか？",
  CFM_KARI_HORYU: "仮保留しますが、よろしいでしょうか？",
  CFM_SHONIN: "承認しますが、よろしいでしょうか？",
  CFM_HORYU: "保留しますが、よろしいでしょうか？",
  CFM_TORIKESI: "取消しますが、よろしいでしょうか？",
  CFM_DELETE: "削除しますが、よろしいでしょうか？",

  CFM_EDIT: "更新しますが、よろしいでしょうか？",
  CFM_SEND_KAITO: "上記回答内容を送信しますが、よろしいでしょうか？",
};
export const ConfirmText = {
  TITLE: "確認",
  YES: "はい",
  NO: "いいえ",
};

export const ErrorMsg = {
  ERR_FAIL_LOGIN: "ログイン失敗しました。",
  ERR_EXPORT_FAIL: "Excel出力が失敗しました。",
  InvalidToken: "認証に失敗しました。再度ログインしてください。",
  Forbidden: "アクセス権限がありません。",
  ERR_RECAPTCHA_LOAD:
    "reCAPTCHAを読み込めませんでした。広告ブロッカー等の拡張機能をご確認の上、ページを再読み込みしてください。",
};
